import React, { useState } from "react";
import { PhoneCall } from "lucide-react";
import { CALL_LOG, MY_OFFERS } from "../demoData";
import { Card, CardHead, PageTitle, Badge, inputCls } from "../ui";

export default function CallLog() {
  const [offer, setOffer] = useState("");
  const [status, setStatus] = useState("");
  const rows = CALL_LOG.filter((c) => (!offer || c.offer === offer) && (!status || c.status === status));
  const earned = rows.reduce((s, c) => s + c.payout, 0);

  return (
    <>
      <PageTitle title="Call Log" sub="Every call tracked in real time via Ringba." />
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <select className={`${inputCls} sm:w-72`} value={offer} onChange={(e) => setOffer(e.target.value)} data-testid="calllog-filter-offer">
          <option value="">All offers</option>
          {MY_OFFERS.map((o) => <option key={o.id} value={o.name}>{o.name}</option>)}
        </select>
        <select className={`${inputCls} sm:w-48`} value={status} onChange={(e) => setStatus(e.target.value)} data-testid="calllog-filter-status">
          <option value="">All statuses</option>
          <option>Paid</option>
          <option>Below Buffer</option>
        </select>
      </div>
      <Card testId="calllog-table">
        <CardHead icon={PhoneCall} title={`${rows.length} calls today`} right={<span className="text-sm font-semibold text-emerald-400" data-testid="calllog-earned">${earned.toLocaleString()} earned</span>} />
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-800">
                {["Call ID", "Time", "Caller", "State", "Offer", "Duration", "Status", "Payout"].map((h) => <th key={h} className="px-5 py-3 font-semibold">{h}</th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800 [&_td]:whitespace-nowrap">
              {rows.map((c) => (
                <tr key={c.id} className="hover:bg-slate-800/30" data-testid={`call-row-${c.id}`}>
                  <td className="px-5 py-3 font-mono text-slate-400">{c.id}</td>
                  <td className="px-5 py-3 text-slate-300 whitespace-nowrap">{c.time}</td>
                  <td className="px-5 py-3 font-mono text-slate-300">{c.caller}</td>
                  <td className="px-5 py-3 text-slate-400">{c.state}</td>
                  <td className="px-5 py-3 text-slate-200">{c.offer}</td>
                  <td className="px-5 py-3 text-slate-300 tabular-nums">{c.duration}</td>
                  <td className="px-5 py-3"><Badge>{c.status}</Badge></td>
                  <td className="px-5 py-3 font-semibold text-white tabular-nums">{c.payout ? `$${c.payout}` : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </>
  );
}
